/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ document: NonNullable<unknown>, caseNumber: NonNullable<unknown> }} Notifications_Document_Classified_Body_ExpandedInputs */

const en_notifications_document_classified_body_expanded = /** @type {(inputs: Notifications_Document_Classified_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The document "${i?.document}" on case ${i?.caseNumber} has been classified.`)
};

const pt_br2_notifications_document_classified_body_expanded = /** @type {(inputs: Notifications_Document_Classified_Body_ExpandedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O documento "${i?.document}" no caso ${i?.caseNumber} foi classificado.`)
};

/**
* | output |
* | --- |
* | "The document \"{document}\" on case {caseNumber} has been classified." |
*
* @param {Notifications_Document_Classified_Body_ExpandedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_document_classified_body_expanded = /** @type {((inputs: Notifications_Document_Classified_Body_ExpandedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Document_Classified_Body_ExpandedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_document_classified_body_expanded(inputs)
	return pt_br2_notifications_document_classified_body_expanded(inputs)
});